import React, { createContext, useState } from 'react';

const UniqueIdContext = createContext();

const UniqueIdProvider = ({ children }) => {
  const [uniqueId, setUniqueId] = useState('');
  const [auth, setAuth] = useState(false);
  const [otpAuth, setOTPAuth] = useState(false);

  return (
    <UniqueIdContext.Provider value={{ uniqueId, setUniqueId, auth, setAuth, otpAuth, setOTPAuth }}>
      {children}
    </UniqueIdContext.Provider>
  );
};

export { UniqueIdContext, UniqueIdProvider };
